import type { PlayableRunState } from '@dissidium/contracts';
import { settle, settlementEligibility } from '../continuity/eligibility.ts';
import { settlementAccount } from '../continuity/ledger.ts';
import type { StoryContent, StorySession } from './story.ts';

/** The opportunity belongs to this exact opening, never to proofs collected later in it. */
export function mysteryOpeningFacts(state: PlayableRunState): string[] {
  return settlementEligibility(state.envelope, state.frozenContinuity).eligible ? ['mystery:fourth-bearing'] : [];
}

/** Only newly performed examinations become this life's verification actions.
 * Reading a deposit, restoring a save or migrating old content cannot mint evidence. */
export function recordMystery(content: StoryContent, before: PlayableRunState, next: PlayableRunState, story: StorySession): void {
  for (const finding of content.mystery?.findings ?? []) {
    if (!finding.actionId || !story.completed.includes(finding.actionId)
      || before.quests.facts.includes(`mystery:verified:${finding.id}`)
      || !next.quests.facts.includes(`mystery:verified:${finding.id}`)
      || next.verifications.some(action => action.proofId === finding.id)) continue;
    if (finding.id === 'P-I2') {
      const old = before.frozenContinuity.persons['person:leth-an'];
      const current = next.continuity.persons['person:leth-an'];
      if (!old || old.lifecycle !== 'dead' || current?.deathEventId !== old.deathEventId || !before.frozenContinuity.closedRuns.length) throw new Error('The death comparison needs the same closed identity in an earlier account.');
    }
    const id = `verification:${before.envelope.runOrdinal}:${finding.actionId}`;
    const routeId = finding.beatId;
    next.verifications.push({ id, proofId: finding.id, routeId, method: finding.id.startsWith('P-M') || finding.id === 'P-T1' ? 'measurement' : 'comparison', witnessId: null });
    next.observations.push({ id: `observation:${before.envelope.runOrdinal}:${finding.id}`, proofId: finding.id, runId: `run:${before.envelope.runOrdinal}`, actionId: id, routeId });
  }
  if (!before.quests.facts.includes('mystery:crossed') && next.quests.facts.includes('mystery:crossed')) {
    const has = (fact: string): boolean => next.quests.facts.includes(fact);
    if (story.beatId !== 'beat:z12-white-joint' || !story.completed.includes('mystery-crossing')
      || !has('mystery:account') || !has('mystery:first-point') || !has('mystery:second-point')) throw new Error('Finish the complete account and walk each measured point first.');
    next.continuity = settle(next.continuity, before.envelope, before.frozenContinuity, settlementAccount(next.continuity), {
      crisisAnswered: has('campaign:B5'), approachPrepared: has('mystery:approach'), crossingCompleted: true,
    });
    next.participation = 'ended';
    next.paused = true;
  }
}
